module.exports = __webpack_public_path__ + "img/b2964bd5-066f-90b6-8c86-91dad79e44120.62b7d978.webp";